import { msrcDarkCustomizations, msrcLightCustomizations } from '../theme';
import { selectThemeFromOs } from './selectThemeFromOs';
/**
 * Choose a theme based on the current theme key.
 */
export const selectThemeFromKey = (themeKey) => {
    switch (themeKey) {
        case 'DARK':
            return msrcDarkCustomizations();
        case 'LIGHT':
            return msrcLightCustomizations();
        case 'AUTO':
        case undefined:
        /* eslint-disable-next-line no-fallthrough */
        default:
            return selectThemeFromOs();
    }
};
